import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ModelStore } from '../../../shared/stores/model.store';
import { Task } from './task.model';
import { TaskService } from './task.service';
import * as _ from 'lodash';
import { tap } from 'rxjs/operators';

@Injectable()
export class TaskStore extends ModelStore<Task> {

    private change$ = new Subject<void>();

    constructor(private taskService: TaskService) {
        super(taskService);
    }

    complete(task: Task) {
        return this.taskService.complete(task).pipe(
            tap(() => this.change$.next())
        );
    }

    reOpen(task: Task) {
        return this.taskService.reOpen(task).pipe(
            tap(() => this.change$.next())
        );
    }

    assign(taskId: number) {
        return this.taskService.assign(taskId).pipe(
            tap(() => this.change$.next())
        );
    }

    get(taskId: number) {
        return this.taskService.get(taskId);
    }

    forBorrower(borrowerId: number): Observable<Task[]> {
      return this.taskService.tasksForBorrower(borrowerId);
    }

    protected afterInject(_task: Task) {
        this.change$.next();
    }
}
